module.exports = __webpack_public_path__ + "img/more.080fd034.png";